import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import InputField from "./components/Inputs/InputField";
import { Box, TextField } from "@mui/material";
import { WORKER_PLAN_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import { getWorkersAction } from "../../../redux/actions/workersActions";
import SubmitBtn from "./components/Buttons/SubmitBtn";
import DropdownIcon from "../components/DropdownIcon/DropdownIcon";

const emptyDay = () => ({ day: "", startTime: "", endTime: "" });

const WorkerPlanModal = () => {
  const dispatch = useDispatch();
  const { workerPlanModalData: modalData } = useSelector(
    (state) => state.workerPlanModal
  );
  const { workers } = useSelector((state) => state.workersPagination);
  const [workDays, setWorkDays] = useState(
    modalData.workDays?.length ? modalData.workDays : [emptyDay()]
  );
  const [leadDays, setLeadDays] = useState(
    modalData.leadDays?.length ? modalData.leadDays : [emptyDay()]
  );
  const [openWorkerDropdown, setOpenWorkerDropdown] = useState(false);

  useEffect(() => {
    dispatch(getWorkersAction());
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      worker:
        typeof modalData.worker === "object"
          ? modalData.worker?._id || ""
          : modalData.worker || "",
    },
    validate: (values) => ({
      ...(!values.worker ? { worker: "Əməkdaş seçin" } : {}),
      ...(workDays.some((item) => !item.day || !item.startTime || !item.endTime)
        ? { workDays: "İş günlərini tam doldurun" }
        : {}),
      ...(leadDays.some((item) => !item.day || !item.startTime || !item.endTime)
        ? { leadDays: "Lead günlərini tam doldurun" }
        : {}),
    }),
  });
  const updateWorker = (event) => {
    formik.setFieldValue("worker", event.target.value);
    dispatch({
      type: WORKER_PLAN_MODAL_ACTION_TYPE.GET_WORKER_PLAN_MODAL,
      payload: {
        data: { ...modalData, worker: event.target.value },
        openModal: true,
      },
    });
  };
  const updateSchedule = (setter, index, key, value) => {
    setter((current) =>
      current.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [key]: value } : item
      )
    );
  };

  const closeModal = () => {
    dispatch({
      type: WORKER_PLAN_MODAL_ACTION_TYPE.GET_WORKER_PLAN_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  return (
    <div className="create-update-modal-con worker-plan-modal">
      <div className="create-update-modal">
        <div className="create-update-modal-head">
          <h2>{modalData?._id ? "İşçi planını yenilə" : "İşçi planı yarat"}</h2>
          <CloseBtn onClick={closeModal} />
        </div>

        <Box
          onSubmit={(e) => e.preventDefault()}
          component="form"
          sx={{
            width: 500,
            maxWidth: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="create-update-modal-form">
            <div className="dropdown-input">
              <div className="input-box">
                <TextField
                  sx={{
                    "& input": {
                      fontSize: "12px",
                      marginRight: "32px",
                    },
                    marginTop: "4px",
                    "& .MuiInputLabel-root.Mui-required:after": {
                      content: '" *"',
                      color: "red",
                      fontSize: "12px",
                    },
                  }}
                  InputLabelProps={{
                    style: { fontSize: "12px", color: "#3F3F3F" },
                  }}
                  fullWidth
                  label="Əməkdaş"
                  autoComplete="off"
                  disabled
                  value={
                    workers.find((item) => item._id === formik.values.worker)
                      ?.fullName || ""
                  }
                  onBlur={() => formik.setFieldTouched("worker", true)}
                  required={true}
                />
                <DropdownIcon
                  setOpenDropdown={setOpenWorkerDropdown}
                  openDropdown={openWorkerDropdown}
                />
              </div>

              <ul
                className={`dropdown-body where-coming ${
                  openWorkerDropdown ? "active" : ""
                }`}
              >
                {workers.map((item) => (
                  <li
                    key={item._id}
                    onClick={() => {
                      updateWorker({ target: { value: item._id } });
                      setOpenWorkerDropdown(false);
                    }}
                  >
                    <h4>{item.fullName}</h4>
                  </li>
                ))}
              </ul>
            </div>
            <InputField
              title="İş günləri"
              value={workDays}
              onChange={(index, key, value) =>
                updateSchedule(setWorkDays, index, key, value)
              }
              onAdd={() => setWorkDays((current) => [...current, emptyDay()])}
              onRemove={(index) =>
                setWorkDays((current) => current.filter((_, i) => i !== index))
              }
            />
            <InputField
              title="Lead günləri"
              value={leadDays}
              onChange={(index, key, value) =>
                updateSchedule(setLeadDays, index, key, value)
              }
              onAdd={() => setLeadDays((current) => [...current, emptyDay()])}
              onRemove={(index) =>
                setLeadDays((current) => current.filter((_, i) => i !== index))
              }
            />
          </div>
        </Box>

        {modalData?._id ? (
          // <div className="create-update-modal-btn-con">
          <SubmitBtn
            formik={formik}
            modalData={modalData}
            workDays={workDays}
            leadDays={leadDays}
            funcType="update"
          />
        ) : (
          // </div>
          <SubmitBtn
            formik={formik}
            modalData={modalData}
            workDays={workDays}
            leadDays={leadDays}
            funcType="create"
          />
        )}

      </div>
    </div>
  );
};

export default WorkerPlanModal;
